<template>
  <div class="container col-2" style="padding-top: 10%">
    <h3 class="h3 text-center">FSS-MPR</h3>
      <form @submit.prevent="submit">
        <div class="form-group">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <span class="oi oi-envelope-closed" title="envelope" aria-hidden="true"></span>
              </div>
            </div>
            <input v-model="email" type="text" class="form-control" id="emailInput"
                   placeholder="Email">
          </div>
        </div>
        <div class="form-group input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <span class="oi oi-key" title="key" aria-hidden="true"></span>
            </div>
          </div>
          <input v-model="password" type="password" class="form-control" id="passwordInput"
                 placeholder="Password">
        </div>
        <div style="padding-top:8px">
          <input type="submit" value="Login" class="form-control btn-success">
        </div>

      </form>
  </div>

</template>

<script>
export default {
  name: 'Login',
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  mounted () {
    if (this.isLoggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('login', { email: this.email, password: this.password })
    }
  },
  data () {
    return {
      email: '',
      password: ''
    }
  }
}
</script>

<style scoped>

</style>
